<template>
  <div class="root">
    <calendar-header v-model="internalValue" :loading="loading" v-on="$listeners"/>
    <calendar-content ref="calendarContent" v-model="internalValue" :avvisi="avvisi" v-on="$listeners"/>
  </div>
</template>

<script>
import CalendarHeader from './CalendarHeader'
import CalendarContent from './CalendarContent'

export default {
    name: 'Calendar',
    components: { CalendarHeader, CalendarContent },
    props: {
        value: String,
        avvisi: {
            type: Array,
            default: () => []
        },
        loading: Boolean
    },
    computed: {
        internalValue: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        closeMenus () {
            this.$refs.calendarContent && this.$refs.calendarContent.closeMenus()
        }
    }
}
</script>

<style lang="scss" scoped>
  .root {
    height: 100%;
    width: 100%;
  }
</style>
